orders-result-checking-jobno
  .result(if="{opts.result}")
    h5.found_title { locale().found_orders }
    .found_result(if="{opts.found_orders.orders}")
      .items(if="{opts.found_orders.orders.length > 0}")
        a.label.label-success(each="{order_data in opts.found_orders.orders}" href="/orders/{order_data.id}" target="_blank")
          | {order_data.job_no}
    .no_result_found_orders(if="{opts.found_orders.orders.length <= 0}")
      .alert.alert-warning
        | { locale().no_result_found_orders }
    h5.notfound_title { locale().notfound_jobno }
    .notfound_result(if="{opts.notfound_jobno.ids}")
      .items(if="{opts.notfound_jobno.ids.length > 0}")
        a.label.label-danger(each="{id in opts.notfound_jobno.ids }" href="/orders?k={id}" target="_blank")
          | { id }
    .no_result_notfound_jobno(if="{!opts.notfound_jobno.ids || opts.notfound_jobno.ids.length <= 0}")
      .alert.alert-success
        | { locale().no_result_notfound_jobno }      
  script(type="typescript").
    this.mixin('base');
    this.watch();
  style(scoped).
    .notfound_title {
      margin-top: 40px;
    }
    .label {
      margin-right: 2px;
      display: inline-block;
    }
